import { type RouteRecordRaw } from 'vue-router'

import { useAuthStore } from '@/auth/useAuthStore'

export const onboardingRouter: RouteRecordRaw[] = [
  {
    beforeEnter: (to, from) => {
      const authStore = useAuthStore()
      if (authStore.isSuperAdmin) {
        return { name: 'onboarding.admin.register' }
      }
    },
    children: [
      {
        component: async () => import('../views/RegisterView.vue'),
        meta: {
          isPublic: true,
          preventAuthenticatedRedirect: true,
          title: 'onboarding.register',
        },
        name: 'onboarding.register',
        path: '/register',
      },
      {
        component: async () => import('../views/RegisterCodeView.vue'),
        meta: {
          isPublic: true,
          preventAuthenticatedRedirect: true,
          title: 'onboarding.register-code',
        },
        name: 'onboarding.register-code',
        path: '/register/code',
      },
      {
        component: async () => import('../views/RegisterUserView.vue'),
        meta: {
          title: 'onboarding.register-user',
        },
        name: 'onboarding.register-user',
        path: '/register/user',
      },
      {
        component: async () => import('../views/RegisterBrandsView.vue'),
        meta: {
          title: 'onboarding.register-brands',
        },
        name: 'onboarding.register-brands',
        path: '/register/brands',
      },
      {
        component: async () => import('../views/SubscribeView.vue'),
        meta: {
          title: 'onboarding.subscribe',
        },
        name: 'onboarding.subscribe',
        path: '/register/subscribe',
      },
    ],
    path: '',
  },
]

export const adminOnboardingRouter: RouteRecordRaw[] = [
  {
    beforeEnter: (to, from) => {
      const authStore = useAuthStore()
      if (!authStore.isSuperAdmin) {
        return { name: 'onboarding.register' }
      }
    },
    children: [
      {
        component: async () => import('../views/AdminRegisterView.vue'),
        meta: {
          isPublic: true,
          preventAuthenticatedRedirect: true,
          title: 'onboarding.admin.register',
        },
        name: 'onboarding.admin.register',
        path: '/admin/register',
      },
      {
        component: async () => import('../views/AdminRegisterUserView.vue'),
        meta: {
          title: 'onboarding.admin.register-user',
        },
        name: 'onboarding.admin.register-user',
        path: '/admin/register/user/:userId',
        props: (route) => ({ userId: route.params.userId }),
      },
      {
        component: async () => import('../views/AdminRegisterBrandsView.vue'),
        meta: {
          title: 'onboarding.admin.register-brands',
        },
        name: 'onboarding.admin.register-brands',
        path: '/admin/register/user/:userId/brands',
        props: (route) => ({ userId: route.params.userId }),
      },
      {
        component: async () => import('../views/AdminSubscribeView.vue'),
        meta: {
          title: 'onboarding.admin.subscribe',
        },
        name: 'onboarding.admin.subscribe',
        path: '/admin/register/user/:userId/subscribe',
        props: (route) => ({ userId: route.params.userId }),
      },
    ],
    path: '',
  },
]

export const onboardingBrandRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/SubscribeBrandView.vue'),
    name: 'brand.onboarding.subscribe',
    path: 'onboarding',
  },
]
